import React from "react";
import { BsLinkedin, BsGithub, BsDownload } from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a
          href="https://www.linkedin.com/in/gr%C3%A9gory-sa%C3%AFmoen-665404183/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://github.com/Saimoen" target="_blank" rel="noreferrer">
          <BsGithub />
        </a>
      </div>
      <div>
        <a
          href={require("../assets/CV.pdf")}
          download="CV.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <BsDownload />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
